<nz-card class="round-border p-4" [nzLoading]="!loaded">
    <a [routerLink]="['/text-translated']">
        <nz-statistic [nzValue]="count | number" [nzTitle]="'text-translated_common_name' | translate"></nz-statistic>
    </a>
</nz-card>